export class SessionSummaryModel {
  nasid;
  storeName;
  totalSessions;

  constructor(obj?: SessionSummaryModel) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/dashboards/reporting/session-summary/session-summary.model.ts